import { render } from "./afterpay-messaging.vue?vue&type=template&id=a98204ca"
import script from "./afterpay-messaging.vue?vue&type=script&lang=js"
export * from "./afterpay-messaging.vue?vue&type=script&lang=js"

import "./afterpay-messaging.vue?vue&type=style&index=0&id=a98204ca&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__